import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MaterialesPage from "../pages/materiales/page";
import NosotrosPage from "../pages/nosotros/page";
import ContactoPage from "../pages/contacto/page";
import DescargasPage from "../pages/descargas/page";
import MaderasPage from "../pages/maderas/page";
import MaderaDetallePage from "../pages/maderas/[slug]/page";
import LacadosPage from "../pages/lacados/page";
import PiedrasNaturalesPage from "../pages/piedras-naturales/page";
import PiedrasCompactasPage from "../pages/piedras-compactas/page";
import PorcelanicosPage from "../pages/porcelanicos/page";
import ResinasMineralesPage from "../pages/resinas-minerales/page";
import AmbientesPage from '../pages/muebles-de-bano/page';
import ProductosPage from '../pages/productos/page';
import ProyectosPage from '../pages/proyectos/page';
import AvisoLegalPage from '../pages/aviso-legal/page';
import Redirect from '../pages/Redirect';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';

// Lazy load heavy configurator and admin pages
const LoginPage = lazy(() => import('../pages/configurador/LoginPage'));
const ResetPasswordPage = lazy(() => import('../pages/configurador/ResetPasswordPage'));
const ConfiguratorPage = lazy(() => import('../pages/configurador/ConfiguratorPage'));
const AdminPage = lazy(() => import('../pages/admin/AdminPage'));

const LazyFallback = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a' }}>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
      <div style={{ width: 40, height: 40, border: '2px solid rgba(218,165,32,0.3)', borderTopColor: '#daa520', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Cargando...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/materiales',
    element: <MaterialesPage />
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />
  },
  {
    path: '/contacto',
    element: <ContactoPage />
  },
  {
    path: '/maderas',
    element: <MaderasPage />
  },
  {
    path: '/maderas/:slug',
    element: <MaderaDetallePage />
  },
  {
    path: '/lacados',
    element: <LacadosPage />
  },
  {
    path: '/piedra-natural',
    element: <PiedrasNaturalesPage />
  },
  {
    path: '/piedra-compacta',
    element: <PiedrasCompactasPage />
  },
  {
    path: '/porcelanicos',
    element: <PorcelanicosPage />
  },
  {
    path: '/resinas-minerales',
    element: <ResinasMineralesPage />
  },
  {
    path: '/descargas',
    element: <DescargasPage />
  },
  {
    path: '/muebles-de-bano',
    element: <AmbientesPage />
  },
  {
    path: '/ambientes',
    element: <Redirect to="/muebles-de-bano" />
  },
  {
    path: '/productos',
    element: <ProductosPage />
  },
  {
    path: '/proyectos',
    element: <ProyectosPage />
  },
  {
    path: '/aviso-legal',
    element: <AvisoLegalPage />
  },
  // ─── Configurador 3D ───
  {
    path: '/configurador/login',
    element: <Suspense fallback={<LazyFallback />}><LoginPage /></Suspense>
  },
  {
    path: '/configurador/reset-password',
    element: <Suspense fallback={<LazyFallback />}><ResetPasswordPage /></Suspense>
  },
  {
    path: '/configurador',
    element: (
      <Suspense fallback={<LazyFallback />}>
        <ProtectedRoute>
          <ConfiguratorPage />
        </ProtectedRoute>
      </Suspense>
    )
  },
  // ─── Admin ───
  {
    path: '/admin',
    element: (
      <Suspense fallback={<LazyFallback />}>
        <ProtectedRoute requireAdmin={true}>
          <AdminPage />
        </ProtectedRoute>
      </Suspense>
    )
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
